<template>
    <div class="container">
        <div class="map-top" id="allmap"></div>
        <ul class="select-list">
            <li @click="showAddressPicker">
                <span >{{area}}</span>
                <i class="map-icon"></i>
            </li>
            <li @click="showAddressPicker">
                <span >{{netname}}</span>
                <i class="map-icon"></i>
            </li>
            <li @click="computedPoints">
                <span>{{targetDist}}</span>
               
            </li>
        </ul>
        <div class="address-list">
               <div class="address-item" v-for="(item,index) in selectedNet" :key="index" >
                    <h5>离我 <span class="a-red-font">{{item.dist}}km</span> </h5>  
                    <p>{{item.netname}}</p> 
                    <p>名字：{{item.netallname}}</p>
                    <p>地址：{{item.address}}</p>
                    <p>联系电话：{{item.publicconntel}}</p>
               </div> 
        </div>
    </div>
</template>

<script>
import addressData from "../store/address/dots";
import addressData2 from "../store/address/dots2";
export default {
    data(){
        return{
            area:'区县',
            netname:'网点',
            targetDist:"离我最近",
            selectedNet:[],
            currentNet:{},
            myPoint:{},
            mulchs:[]
        }
    },
    mounted() {
        this.map = new BMap.Map("allmap");
        let _this=this;
        var point = new BMap.Point(116.331398, 39.897445);
        this.map.centerAndZoom(point, 12);
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(
            function(r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                     _this.myPoint=r.point;
                    let point=new BMap.Marker(r.point);
                    _this.map.addOverlay(point);
                    _this.map.panTo(r.point);
                    _this.computedPoints();
                } else {
                    alert('failed'+this.getStatus());
                }
            },
            { enableHighAccuracy: true }
        );

        this.addressPicker = this.$createCascadePicker({
            title: "网点查询",
            data: addressData,
            onSelect: this.selectHandle,
            onCancel: this.cancelHandle
        });

     
    },
    methods: {
        showAddressPicker() {
            this.addressPicker.show();
        },
        selectHandle(selectedVal, selectedIndex, selectedText) {
            this.mulchs.forEach(item=>this.map.removeOverlay(item));
            this.area=selectedText[0];
            this.netname=selectedText[1];
            this.currentNet=addressData2.find(item=>item.id===selectedVal[1]);
            this.selectedNet=[this.currentNet];
            this.currentNet.dist=(this.map.getDistance(this.myPoint,this.currentNet.location)/1000).toFixed(1);
            let point= new BMap.Marker(this.currentNet.location);
            this.map.addOverlay(point);
            this.map.panTo(point);
            this.mulchs.push(point)
        },
        onCancel() {

        },
        computedPoints(){
             this.mulchs.forEach(item=>this.map.removeOverlay(item));
             let targets=[];
              targets=addressData2.map((item,index)=>{
                   item.dist=(this.map.getDistance(this.myPoint,item.location)/1000).toFixed(1);
                   return item
             }).sort((a,b)=>{
                 return a.dist-b.dist;
             }).splice(0,3);
            this.selectedNet=targets;
            this.selectedNet.forEach(item=>{
                  let point= new BMap.Marker(item.location);
                  this.map.addOverlay(point);
                  this.map.panTo(point);
                  this.mulchs.push(point)
            })
        }
    }
};
</script>

<style lang="scss" scoped>
</style>